import React from 'react'
import classes from './ImageModalContent.module.sass'
import { imageUrl } from '../../../../utils/constants'

type Props = {
  image: string
  alt?: string
}

export const ImageModalContent = ({ image, alt }: Props) => {
  return (
    <div className={classes.Container}>
      <img
        src={`${imageUrl + image}`}
        className={classes.Image}
        alt={alt ? alt : 'Изображение заказа'}
      />
    </div>
  )
}
